<template>
    <div :class="{ center: isCentered, right: isRightAlign }">
        <div v-if="content.sanityImage" class="column--img-square">
            <EmbedSanityImage
                :selectedImage="
                    content.sanityImage && content.sanityImage.selectedImage
                "
                :image-align="img.align"
                :alt="
                    content.sanityImage && content.sanityImage.alt && content.sanityImage.alt[$i18n.locale]
                        ? content.sanityImage.alt
                        : { en: 'c3controls image', es: 'c3controls image' }
                "
                width="250"
                height="300"
            />
        </div>
        <div v-if="content.heading && content.heading[$i18n.locale]">
            <component
                :is="headingSize"
                :class="{ uppercase: headingUppercase }"
                >{{ content.heading[$i18n.locale] }}</component
            >
        </div>
        <div v-if="content.blurbage && content.blurbage[$i18n.locale]">
            <BlockContent
                :blocks="content.blurbage[$i18n.locale]"
                :serializers="serializers"
            />
        </div>
        <div v-if="content.ctaLinks && content.ctaLinks.links">
            <CtaLinks :links="content.ctaLinks.links" />
        </div>
    </div>
</template>
<script>
import CtaLinks from '~/components/CtaLinks.vue'
import serializers from '~/util/sanity/serializers'
import EmbedCloudinary2 from '~/components/embeds/EmbedCloudinary2.vue'
import EmbedSanityImage from '~/components/embeds/EmbedSanityImage.vue'
import setCloudinaryData from '~/util/setCloudinaryData'
export default {
    name: 'ColumnImageBlurb',
    components: {
        CtaLinks,
        EmbedCloudinary2,
        EmbedSanityImage,
    },
    props: {
        content: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            serializers,
        }
    },
    computed: {
        headingSize() {
            if (!this.content.headingSize) {
                return 'h3'
            } else {
                return this.content.headingSize
            }
        },
        headingUppercase() {
            return this.content.headingUppercase === true
        },
        isCentered() {
            return this.content.textAlign === 'center'
        },
        isRightAlign() {
            return this.content.textAlign === 'right'
        },
        imgWidth() {
            return '250px'
        },
        img() {
            // console.log(this.image)
            return this.image ? setCloudinaryData(this.image, 'column') : {}
        },
    },
}
</script>
